module.exports = __webpack_public_path__ + "assets/59e74dbf92166e55532d1bc5812adbf5.png";